import { createSlice } from "@reduxjs/toolkit";

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    feedbacks: [],
    feedbackPaginations: {},
    isAddFeedbackResponse: false,
    isUpdateFeedbackResponse: false,
    isFeedbackError: false,
    singleLeadFeedback: [],
    singleLeadCompletionNotes: {},
    askFeedbackResponse: false,
    isUpdatedCompletedFeedbackResponse:false,
  },

  reducers: {
    getAllFeedbackListAction: (state) => {},
    setAllFeedbackListAction: (state, { payload }) => {
      console.log("payload", payload);
      // const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.feedbacks = payload;
    },

    addFeedbackAction: (state, { payload }) => {},
    setAddFeedbackResponse: (state, { payload }) => {
      state.isAddFeedbackResponse = payload;
    },

    updateFeedbackAction: (state, { payload }) => {},
    setUpdateFeedbackResponse: (state, { payload }) => {
      state.isUpdateFeedbackResponse = payload;
    },

    getSingleLeadFeedbackAction: (state, { payload }) => {},
    setSingleLeadFeedbackResponse: (state, { payload }) => {
      state.singleLeadFeedback = payload;
    },

    getSingleLeadCompletionNotesAction: (state, { payload }) => {},
    setSingleLeadCompletionNotesResponse: (state, { payload }) => {
      state.singleLeadCompletionNotes = payload;
    },

    getAskFeedbackAction: (state, { payload }) => {},
    setAskFeedbackResponse: (state, { payload }) => {
      state.askFeedbackResponse = payload;
    },

    updatedCompletedFeedbackAction: (state, { payload }) => {},
    setUpdatedCompletedFeedbackResponse: (state, { payload }) => {
      state.isUpdatedCompletedFeedbackResponse = payload;
    }
  },
});

const {
  getAllFeedbackListAction,
  setAllFeedbackListAction,
  addFeedbackAction,
  setAddFeedbackResponse,
  updateFeedbackAction,
  setUpdateFeedbackResponse,
  getSingleLeadFeedbackAction,
  setSingleLeadFeedbackResponse,
  getSingleLeadCompletionNotesAction,
  setSingleLeadCompletionNotesResponse,
  getAskFeedbackAction,
  setAskFeedbackResponse,
  updatedCompletedFeedbackAction,
setUpdatedCompletedFeedbackResponse
} = feedbackSlice.actions;

export {
  getAllFeedbackListAction,
  setAllFeedbackListAction,
  addFeedbackAction,
  setAddFeedbackResponse,
  updateFeedbackAction,
  setUpdateFeedbackResponse,
  getSingleLeadFeedbackAction,
  setSingleLeadFeedbackResponse,
  getSingleLeadCompletionNotesAction,
  setSingleLeadCompletionNotesResponse,
  getAskFeedbackAction,
  setAskFeedbackResponse,
  updatedCompletedFeedbackAction,
setUpdatedCompletedFeedbackResponse
};

export default feedbackSlice.reducer;
